import { FC } from '../../../Services'
import { showToast } from '../../../utils/toast'

export const setAllErrorsWithKeyLabel = async () => {
  try {
    await FC.service('info').create({ action: 'updateAllConversationsWithError' })
    showToast('success', 'Success', 'Update corretto')
  } catch (error) {
    showToast('error', 'Errore', error?.message || 'Update non andato a buon fine')
  }
}
export const setAllErrorsTAProfile = async () => {
  try {
    await FC.service('info').create({ action: 'updateAllConversationsErrorTAProfile' })
    showToast('success', 'Success', 'Update corretto')
  } catch (error) {
    showToast('error', 'Errore', error?.message || 'Update non andato a buon fine')
  }
}
export const setAllErrorOutOfOffice = async () => {
  try {
    await FC.service('info').create({ action: 'updateAllConversationsErrorOutOfOffice' })
    showToast('success', 'Success', 'Update corretto')
  } catch (error) {
    showToast('error', 'Errore', error?.message || 'Update non andato a buon fine')
  }
}
